import { getDomainUrl } from 'coreOld/utils';

export const oldSignOutPath = () => `${getDomainUrl()}/auth/index/logout/`;
